import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';

var pixelSrc = "data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==";
var Pixel = props => /*#__PURE__*/React.createElement("img", _extends({
  alt: "",
  src: pixelSrc
}, props));

export { Pixel, pixelSrc };
//# sourceMappingURL=index.js.map
